import React from 'react';
import {Field, reduxForm} from 'redux-form'
import FlatButton from 'material-ui/FlatButton';

import DoneIcon from 'material-ui/svg-icons/action/done';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';
import * as colors from 'material-ui/styles/colors';

import FormText from '../../../components/FormText'


class PasswordForm extends React.Component {

  render() {

    const {
      error,
      handleSubmit,
      onFormRegistClick,
     } = this.props

    return (

      <form onSubmit={handleSubmit(() => {})}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}
        
          <div className="row">

            <div className="col-4">

              <Field
                name="oldPassword"
                component={FormText}
                label="旧パスワード"
                style={{ width: '100%' }}
                type="password"
              />

            </div>

          </div>

          <div className="row">

            <div className="col-4">

              <Field
                name="password"
                component={FormText}
                label="新パスワード"
                style={{ width: '100%' }}
                type="password"
              />

            </div>

            <div className="col-4">

              <Field
                name="passwordConfirm"
                component={FormText}
                label="新パスワード確認"
                style={{ width: '100%' }}
                type="password"
              />

            </div>

          </div>

          <div className="row" style={{marginTop: 20}}>

            <div className="col-6" style={{paddingTop: 5, display: 'flex', justifyContent:'flex-start'}}>

              <FlatButton
                label="登録"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '100px', marginRight: '20px' }}
                backgroundColor={colors.cyan700}
                hoverColor={colors.cyan900}
                icon={<DoneIcon color={colors.white} />}
                onClick={handleSubmit(onFormRegistClick)}
              />

            </div>

            <div className="col-6" style={{textAlign: 'right'}}>
            </div>

          </div>

      </form>

    )

  }

}

PasswordForm = reduxForm({
  form: 'passwordMasterForm',
  enableReinitialize: true,
})(PasswordForm)

export default PasswordForm




// WEBPACK FOOTER //
// ./src/containers/master/password/PasswordForm.js